"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesAPI = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const getUrl = (endPath) => {
    const instance = (0, trade_utils_lib_1.getTradeDependencyInstance)();
    const host = instance.getRunTimeHost().tradingBotApiHost;
    return `${host}${endPath}`;
};
// API document: https://pionex.atlassian.net/wiki/spaces/backend/pages/367790134/futures+lite
var SimpleFuturesAPI;
(function (SimpleFuturesAPI) {
    /**
     * 创建订单
     * * @param request SimpleFuturesCreateRequest
     */
    SimpleFuturesAPI.createOrder = (request) => {
        const url = getUrl("/futures_lite/");
        return trade_utils_lib_1.Network.post({ url, data: request, authType: trade_utils_lib_1.AuthType.AccessAndSpot, signature: true });
    };
    /**
     * 关闭（平仓）订单
     * @param request SimpleFuturesCloseRequest
     */
    SimpleFuturesAPI.closeOrder = (request) => {
        const { bu_order_id } = request, bodyRequest = __rest(request, ["bu_order_id"]);
        const url = getUrl(`/futures_lite/${bu_order_id}/close_position/`);
        return trade_utils_lib_1.Network.post({ url, data: bodyRequest, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 一键全平
     * @param request SimpleFuturesCloseRequest
     */
    SimpleFuturesAPI.closeAllOrder = (request) => {
        const url = getUrl("/futures_lite/close_all/");
        return trade_utils_lib_1.Network.get({ url, data: request, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 获取订单列表
     * @param request SimpleFutures.OrderListRequest
     */
    SimpleFuturesAPI.getOrderList = (request) => {
        const url = getUrl("/futures_lite/positions/");
        return trade_utils_lib_1.Network.get({ url, data: request, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 获取订单详情
     * @param request SimpleFutures.OrderRequest
     */
    SimpleFuturesAPI.getOrder = (request) => {
        const url = getUrl(`/futures_lite/${request.bu_order_id}/`);
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 获取资金费列表
     * @param request SimpleFutures.FundingFeeRequest
     */
    SimpleFuturesAPI.getFundingFee = (request) => {
        const { bu_order_id } = request, bodyRequest = __rest(request, ["bu_order_id"]);
        const url = getUrl(`/futures_lite/${request.bu_order_id}/funding_fee/`);
        return trade_utils_lib_1.Network.get({ url, data: bodyRequest, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 修改保证金
     * @param request SimpleFutures.TransferProfitRequest
     */
    SimpleFuturesAPI.transferProfit = (request) => {
        const { bu_order_id } = request, bodyRequest = __rest(request, ["bu_order_id"]);
        const url = getUrl(`/futures_lite/${request.bu_order_id}/transfer/`);
        return trade_utils_lib_1.Network.post({ url, data: bodyRequest, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 获取保证金记录
     * @param request SimpleFutures.MarginRecordsRequest
     */
    SimpleFuturesAPI.getMarginRecords = (request) => {
        const { bu_order_id } = request, bodyRequest = __rest(request, ["bu_order_id"]);
        const url = getUrl(`/futures_lite/${request.bu_order_id}/transfer/`);
        return trade_utils_lib_1.Network.get({ url, data: bodyRequest, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 仓位信息统计
     */
    SimpleFuturesAPI.getStats = () => {
        const url = getUrl("/futures_lite/stats/");
        // NOTE: 后端数据是经过 symbol 字母排序的
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 修改止盈止损
     * tpsl: {"mode":"simple_rate", "data":{"profit_rate":"0.2","loss_rate":"-0.1"}}
     * doc: https://pionex.atlassian.net/wiki/spaces/backend/pages/367790134/futures+lite#%E4%BF%AE%E6%94%B9%E6%AD%A2%E7%9B%88%E6%AD%A2%E6%8D%9F%E5%8F%82%E6%95%B0
     */
    SimpleFuturesAPI.editTPSL = (request) => {
        const { orderId, tpsl } = request;
        const url = getUrl(`/futures_lite/${orderId}/edit_tpsl/`);
        let tpslParams = "";
        if (tpsl) {
            // 全部取消设置直接传空串，即："tp_sl":""
            try {
                tpslParams = JSON.stringify(tpsl);
            }
            catch (err) { }
        }
        return trade_utils_lib_1.Network.post({ url, data: { tp_sl: tpslParams }, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
    };
    /**
     * 查询可开仓限额的名义价值
     */
    SimpleFuturesAPI.getPositionLimit = (request) => {
        return trade_utils_lib_1.Network.get({
            url: getUrl("/futures_lite/position_limit/"),
            authType: trade_utils_lib_1.AuthType.AccessAndSpot,
            data: request,
        });
    };
})(SimpleFuturesAPI = exports.SimpleFuturesAPI || (exports.SimpleFuturesAPI = {}));
